import "./Header.scss";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import MiddleNavigation from "../navigation/MiddleNavigation";
import TopNavigation from "../navigation/TopNavigation";
import BottomNavigation from "../navigation/BottomNavigation";
import { fetchProfileAsync } from "../../../features/user/userSlice";
import { useIsAuthenticated } from "@azure/msal-react";

const Header = (props) => {
  const dispatch = useDispatch();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchProfileAsync());
    }
  }, [isAuthenticated, dispatch]);

  return (
    <header>
      <TopNavigation />
      <MiddleNavigation />
      <BottomNavigation />
    </header>
  );
};

export default Header;
